import {
  AuthorizationList,
  CanAccess,
} from "../../../components/template/authorization/Authorization";
import { Button } from "antd";

export const initFilterInput = {
  searchName: "",
  page: 1,
  pageSize: 10,
  transactionStartDate: null,
  transactionEndDate: null,
  sortingField: "pick_up_date",
  sortingOrder: "ASC",
};

export const renderColumns = (handleEdit, handleDetail) => {
  return [
    {
      dataIndex: "req_jemput",
      key: "req_jemput",
      title: "Request Jemput Gadai",
      backend_key: "pick_up_date",
    },
    {
      dataIndex: "tanggal_jemput",
      backend_key: "pick_up_date",
      key: "tanggal_jemput",
      title: "Tanggal & Waktu Jemput",
    },
    {
      dataIndex: "nama_nasabah",
      key: "nama_nasabah",
      title: "Nama Nasabah",
    },
    {
      dataIndex: "no_telp",
      key: "no_telp",
      title: "No. Telepon ",
    },
    {
      dataIndex: "barang_jaminan",
      key: "barang_jaminan",
      title: "Barang Jaminan ",
    },
    {
      dataIndex: "lokasi_jemput",
      key: "lokasi_jemput",
      title: "Lokasi Jemput ",
    },
    {
      dataIndex: "konfirmasi",
      key: "konfirmasi",
      title: "Konfirmasi Sebelum",
      render: (text) => (
        <div
          style={{
            textAlign: "left",
            color: "red",
            fontWeight: "bold",
            fontSize: "14px"
          }}
        >
          {text}
        </div>
      ),
    },

    {
      dataIndex: "action",
      key: "action",
      title: "Aksi",
      width: "10%",
      render: (_, record) => (
        <div className="d-flex flex-column">
          <div className="mr-2 mb-2">
            <CanAccess
              role={AuthorizationList.update_pick_up_gadai}
              yes={
                <Button
                  variant="primary"
                  className="btn-action btn-detail"
                  onClick={() => {
                    handleEdit(record)
                  }
                  }
                >
                  Konfirmasi Jadwal
                </Button>
              }
            />
          </div>
          <div className="mr-2">
            <Button
              onClick={() => handleDetail(record)}
              variant="outline-primary"
              className="btn-action btn-default font-weight-semi-bold"
              style={{ width: "145px" }}
            >
              Detail
            </Button>
          </div>
        </div>
      ),
    },
  ];
};
